import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex-shrink-0">
            <a href="/" className="flex items-center gap-3 group">
              {/* Name + title */}
              <div className="flex flex-col leading-tight">
                <span className={`text-sm font-bold tracking-wide transition-colors duration-300 ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
                  Charlie Peters
                </span>
                <span className={`text-xs font-medium tracking-wider uppercase transition-colors duration-300 ${isScrolled ? 'text-pink-600' : 'text-pink-300'}`}>
                  Meta Paid Specialist
                </span>
              </div>
            </a>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <a href="#about" className={`text-sm font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>
              About
            </a>
            <a href="#package" className={`text-sm font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>
              Services
            </a>
            <a
              href="#contact"
              className="bg-gradient-to-r from-pink-600 to-pink-700 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:from-pink-700 hover:to-pink-800 transition-all whitespace-nowrap"
            >
              Get Started Today
            </a>
          </div>

          <button
            className="md:hidden"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-gray-900' : 'text-white'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white shadow-lg">
          <div className="px-4 pt-2 pb-4 space-y-3">
            <a href="#about" className="block py-2 text-sm font-medium text-gray-700 hover:text-teal-600">About</a>
            <a href="#package" className="block py-2 text-sm font-medium text-gray-700 hover:text-teal-600">Services</a>
            <a href="#contact" className="block py-2 text-sm font-medium bg-gradient-to-r from-pink-600 to-pink-700 text-white px-6 rounded-full text-center">
              Get Started Today
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
